// New settings item is added in this file, lead the numbers

import { IconProp } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowRightArrowLeft,
  faBoltAuto,
  faDownload,
  faPrintMagnifyingGlass,
  faStickyNote,
  faWeightScale,
  faWarehouseFull,
  faPrint as faPrintSolid,
  faFlaskGear,
  faBug,
} from '@fortawesome/pro-duotone-svg-icons'
import { faBoxes, faPrint, faScannerGun, faGear, faCamera } from '@fortawesome/pro-light-svg-icons'
import { UnstructuredSettingsFlowId } from './useUnstructuredSettingsFlow'
import { toastError, toastSuccess } from '../../lib/toastHelpers'

// 1. Add new key to settings store type
export type SettingsStore = {
  moveOrderStatusRightAfterPicking: boolean
  strictDepotFilter: boolean
  printer: string
  printer2: string
  printer2byBrowser: boolean
  pickingPieceByPiece: boolean
  cameraDeviceId: string
}

// 2. Add default value for this key
export const settingsInitialStore: SettingsStore = {
  moveOrderStatusRightAfterPicking: true,
  strictDepotFilter: false,
  printer: '',
  printer2: '',
  printer2byBrowser: false,
  pickingPieceByPiece: false,
  cameraDeviceId: '',
}

// 3. Add new value to settings structure array
export const settingsStructure: SettingsItem[] = [
  {
    icon: faWarehouseFull,
    label: 'Pouze objednávky vyskladnitelné z vybraného skladu',
    description: 'Zobrazovat jen ty objednávky, které lze vyskladnit z aktuálně vybraného skladu.',
    storeKey: 'strictDepotFilter',
    type: 'toggle',
    group: 'Objednávky',
  },
  {
    icon: faBoltAuto,
    label: 'Posunout stav objednávky automaticky',
    description:
      'Při ukončení balení všech položek se stav objednávky automaticky změní na „zabaleno“ a vytiskne se štítek.',
    storeKey: 'moveOrderStatusRightAfterPicking',
    type: 'toggle',
    group: 'Objednávky',
  },
  {
    icon: faBoltAuto,
    label: 'Vyskladňování po kusech',
    description: 'Povolit skenování po jednom kuse místo po položkách.',
    storeKey: 'pickingPieceByPiece',
    type: 'toggle',
    group: 'Objednávky',
  },
  {
    icon: faStickyNote,
    label: 'Tiskárna štítků',
    description: 'Zvolte tiskárnu pro tisk štítků',
    storeKey: 'printer',
    unstructFlowId: 'printer1',
    type: 'picker',
    group: 'Tisk',
    isDesktopOnly: true,
  },
  {
    icon: faPrintSolid,
    label: 'Tiskárna A4',
    description: 'Zvolte tiskárnu pro tisk A4 dokumentů',
    storeKey: 'printer2',
    unstructFlowId: 'printer2',
    type: 'picker',
    isDesktopOnly: true,
    group: 'Tisk',
  },
  {
    icon: faPrintMagnifyingGlass,
    label: 'Tisk A4 pomocí browser dialogu',
    description: 'Použít dialog pro tisk A4 přímo v prohlížeči',
    storeKey: 'printer2byBrowser',
    unstructFlowId: 'printer2byBrowser',
    type: 'toggle',
    group: 'Tisk',
  },
  {
    icon: faFlaskGear,
    label: 'Test čtečky',
    description: 'Otevřít testovací okno čtečky čárových kódů',
    type: 'button',
    key: 'scannerTest',
    unstructFlowId: 'scannerTest',
    group: 'Čtečka',
  },
  {
    icon: faDownload,
    label: 'Stažení desktop aplikace',
    buttonLabel: 'Stáhnout',
    description: 'Přesměrování na stránku, kde si můžete stáhnout desktopovou expediční aplikaci.',
    type: 'button',
    key: 'downloadDesktopApp',
    isWebOnly: true,
    buttonAction: () => {
      window.open('https://depoto.cz/apps', '_blank')
    },
    group: 'Aplikace',
  },
  {
    icon: faWeightScale,
    label: 'Připojení Dymo váhy',
    description: 'Nastaví usb pravidla pro Dymo váhy',
    type: 'button',
    buttonLabel: 'Nastavit',
    key: 'setUdevRulesButton',
    buttonAction: () => {
      ;(window as any)._depoto?.setUdevRules?.()
    },
    isDesktopOnly: true,
    group: 'Aplikace',
  },
  {
    icon: faBug,
    label: 'Show Error Toast',
    description: 'Nastaví usb pravidla pro Dymo váhy',
    type: 'button',
    buttonLabel: 'Show Error Toast',
    key: 'setUdevRulesButton',
    buttonAction: () => {
      toastError('This is a error toast!')
    },
    group: 'Test',
  },
  {
    icon: faBug,
    label: 'Show Success Toast',
    description: 'Nastaví usb pravidla pro Dymo váhy',
    type: 'button',
    buttonLabel: 'Show Success Toast',
    key: 'setUdevRulesButton',
    buttonAction: () => {
      toastSuccess('This is a success toast!')
    },
    group: 'Test',
  },
  {
    icon: faCamera,
    label: 'Kamera pro fotky objednávek',
    description: 'Vyberte výchozí kameru pro pořizování fotek k objednávkám.',
    storeKey: 'cameraDeviceId',
    unstructFlowId: 'camera1',
    type: 'picker',
    group: 'Kamera',
  },
  {
    icon: faCamera,
    label: 'Test kamery',
    description: 'Otevře náhled kamery pro otestování funkčnosti a kvality obrazu.',
    type: 'button',
    key: 'cameraTest',
    unstructFlowId: 'cameraTest',
    group: 'Kamera',
  },
]
// 4. Use the setting in the app and enjoy :)

export const groupSettings = [
  {
    name: 'Objednávky',
    icon: faBoxes,
  },
  {
    name: 'Tisk',
    icon: faPrint,
  },
  {
    name: 'Čtečka',
    icon: faScannerGun,
  },
  {
    name: 'Kamera',
    icon: faCamera,
  },
  {
    name: 'Aplikace',
    icon: faGear,
  },
  {
    name: 'Test',
    icon: faGear,
  },
]

export type SettingsItem = {
  icon: IconProp
  label: string
  description?: string
  isDevLocked?: boolean
  isDesktopOnly?: boolean
  isWebOnly?: boolean
  unstructFlowId?: UnstructuredSettingsFlowId
  group?: string
} & (
  | {
      type: 'picker'
      storeKey: keyof SettingsStore
      pickerOptions?: {
        label: string
        value: string
      }[]
    }
  | {
      icon: IconProp
      label: string
      type: 'button'
      key: string
      buttonLabel?: string
      buttonAction?: () => void
    }
  | {
      type: 'toggle'
      storeKey: keyof SettingsStore
    }
)
